export const UPDATE_COMMENT_BY_RESULT_REQUEST = 'UPDATE_COMMENT_BY_RESULT_REQUEST';

export const updateCommentByResultRequest = ( id, updateData ) => ({
    type: UPDATE_COMMENT_BY_RESULT_REQUEST,
    payload: {
        id,
        updateData
    }
});
